module.exports = {
  context: {
    heading: {
      tag: 'h2',
      class: 'heading-2',
      text: 'Section heading example'
    }
  }
}
